'use client';

import { useAuthStore } from '@/stores/AuthStore';

import { useAdGuards } from './useAdGuards';

export type AdpopcornStatus = 'unsupported' | 'app-install' | 'login' | 'ready';

interface UseAdpopcornStatusReturn {
  status: AdpopcornStatus;
  isExternalWebview: boolean;
}

export const useAdpopcornStatus = (): UseAdpopcornStatusReturn => {
  const { isMounted, isWelloApp, isExternalWebview } = useAdGuards();
  const memberOAuth = useAuthStore((state) => state.myInfo?.memberOAuth);

  const status: AdpopcornStatus = (() => {
    if (!isMounted || isExternalWebview) return 'unsupported';
    if (!isWelloApp) return 'app-install';
    if (!memberOAuth) return 'login';

    return 'ready';
  })();

  return { status, isExternalWebview };
};
